import { initalizerTypes } from '../actions/initializer_actions';
export const vacanciesTypes = {
  CREATE_NEW: 'jobs/CREATING_NEW_POST',
  EDIT_DATA: 'jobs/EDITING_POST',
  REMOVE_JOBS: 'jobs/REMOVING_POST',
  CURRENT_JOB: 'jobs/CURRENT_JOB',
};
const jobsReducerDefaultState = [];

export default (state = jobsReducerDefaultState, action) => {
  switch (action.type) {
    case initalizerTypes.FETCH_VACANCY_DATA:
      return [...action.vacancies];
    case vacanciesTypes.CREATE_NEW:
      return [...state, action.payload];
    case vacanciesTypes.EDIT_DATA:
      return state.map((vacante) => {
        if (vacante.jobID === action.id) {
          return {
            ...vacante,
            ...action.updates,
          };
        } else {
          return vacante;
        }
      });
    case vacanciesTypes.REMOVE_JOBS:
      return [...action.newValues];
    default:
      return state;
  }
};
